import { useNavigate } from "react-router-dom";
import { Marker, Popup } from "react-leaflet";
import { ErrorBanner } from "../components/ErrorBanner";
import { StationDots, TrainMap } from "../components/TrainMap";
import { useCatalog } from "../context/CatalogContext";
import { useGpsFeed } from "../hooks/useGpsFeed";
import { dash, formatLate, trainLabel } from "../api/format";
import { isValidGps } from "../api/ws";
import { trainIcon } from "../mapIcons";

export function LiveMap() {
  const navigate = useNavigate();
  const { stations, trainsById, error, reload } = useCatalog();
  const { positions, connected } = useGpsFeed({ kind: "all" });
  const list = [...positions.values()].filter(isValidGps);

  return (
    <div className="map-page">
      <div className="map-toolbar">
        <div>
          <h1>Live map</h1>
          <p className="muted">WebSocket subscribe all. {connected ? "Connected." : "Connecting…"} {list.length} position{list.length === 1 ? "" : "s"}.</p>
        </div>
        {list.length === 0 ? <span className="pill pill-warn">no live position yet</span> : null}
      </div>
      <ErrorBanner error={error} onRetry={reload} />
      <div className="map-frame">
        <TrainMap>
          <StationDots stations={stations} />
          {list.map((p) => (
            <Marker
              key={p.train_id}
              position={[p.latitude, p.longitude]}
              icon={trainIcon}
              eventHandlers={{
                click: () => navigate(`/map/${p.train_id}`),
              }}
            >
              <Popup>
                <strong>{trainLabel(trainsById.get(p.train_id) ?? { train_name: `Train ${p.train_id}` })}</strong>
                <div>Speed: {dash(p.speed_kmh)} km/h</div>
                <div>Late: {formatLate(p.late_by_minutes)}</div>
                <div>Next ETA: {dash(p.next_station_eta)}</div>
                <button type="button" className="linkish" onClick={() => navigate(`/map/${p.train_id}`)}>
                  Track this train
                </button>
              </Popup>
            </Marker>
          ))}
        </TrainMap>
      </div>
    </div>
  );
}
